export default __webpack_public_path__ + "static/media/EW1211Ab.8ebc6f83.jpg";